const checkDeductionValidation = (products) => {
  return products.every((product) => product.deduction_is_valid === true);
};
export default checkDeductionValidation;
